/** @jsxImportSource @emotion/react */
import { memo } from "react";

import {
  optionLabelRequired,
  optionLabelAny,
} from "assets/css/stylesCss";

/**
 * 見出し(h3)
 * @param {String} title タイトル
 * @param {Boolean} required true : 必須
 *                           false: 任意
 * @param {String} marginBottom マージン値
 */
const H3 = memo(({ title, required, marginBottom = "16px" }) => {
  return (
    <h3 style={{ marginBottom: marginBottom }}>
      {title}
      {required
        ? <span css={optionLabelRequired}>必須</span>
        : <span css={optionLabelAny}>任意</span>
      }
    </h3>
  );
});

export default H3;
